/**
* Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'left-right',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    // gsap.registerPlugin( ScrollTrigger );
    init: function() {
      if ( $( '.left-right__marquee' ).length ) {
        $( '.left-right__marquee' ).each( function( index, element ) {
          const textWidth = $( element ).find( '.left-right__slide-text' ).outerWidth();
          new Splide( element, {
            type: 'loop',
            fixedWidth: `${textWidth}px`,
            gap: '16px',
            drag: false,
            autoScroll: {
              speed: 1,
              pauseOnHover: false,
            },
            arrows: false,
            pagination: false,
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'left-right', COMPONENT );
} )( app );
